import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.16.5_@vue+compile_a2b1b989350e5e5b0abd1c8164a5ab32/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.16.5_@vue+compile_a2b1b989350e5e5b0abd1c8164a5ab32/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "access-public-store": () => import("/opt/buildhome/repo/middleware/access-public-store.ts"),
  auth: () => import("/opt/buildhome/repo/middleware/auth.ts"),
  "pos-auth": () => import("/opt/buildhome/repo/middleware/pos-auth.ts"),
  "super-admin": () => import("/opt/buildhome/repo/middleware/super-admin.ts")
}